import { render, staticRenderFns } from "./UpdateLocationModal.vue?vue&type=template&id=6eda0c5f"
import script from "./UpdateLocationModal.vue?vue&type=script&lang=ts"
export * from "./UpdateLocationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports